import { ConnectedRouter } from "connected-react-router";
import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { history } from "../../store/history";
import { useSelector } from "react-redux";
import {
	ROUTE_DASHBOARD,
	ROUTE_HOSTELS,
	ROUTE_PUBLIC_REGISTER,
	ROUTE_REGISTRATIONS,
	ROUTE_ROOT,
	ROUTE_SIGNIN,
	ROUTE_VOLUNTEER_REGISTER,
} from "./routes";
import Signin from "../Signin/Signin";
import Register from "../Register/Register";
import Dashboard from "../Dashboard/Dashboard";
import Hostel from "../Hostel/Hostel";
import Registrations from "../Registrations/Registrations";
import Unauthorized from "../Shared/Unauthorized";
import VolunteerRegistration from "../VolunteerRegistration/VolunteerRegistration";

export function getProtectedRoutes(isSignedIn) {
	if (isSignedIn) {
		return (
			<>
				<Route exact path={ROUTE_DASHBOARD} component={Dashboard} />
				<Route exact path={ROUTE_HOSTELS} component={Hostel} />
				<Route exact path={ROUTE_REGISTRATIONS} component={Registrations} />
			</>
		);
	}

	return <Route path="*" component={Unauthorized} />;
}
export function AppRouter() {
	const auth = useSelector((state) => state.auth);
	const isSignedIn = auth.signedIn;

	return (
		<ConnectedRouter history={history}>
			<Switch>
				<Route exact path={ROUTE_SIGNIN} component={Signin} />
				<Route exact path={ROUTE_VOLUNTEER_REGISTER} component={VolunteerRegistration} />
				<Route exact path={ROUTE_PUBLIC_REGISTER} component={Register} />
				{getProtectedRoutes(isSignedIn)}

				<Route render={() => <Redirect to={ROUTE_DASHBOARD} />} />

				<Route path="*" component={Unauthorized} />
			</Switch>
		</ConnectedRouter>
	);
}
